import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

Amplify.configure({
  ...awsExports,
  Auth: {
    ...awsExports.Auth,
    identityPoolId: 'us-east-1:8749c4d3-a8ae-4cfa-adeb-997b0a507754',
    region: 'us-east-1',
    userPoolId: 'us-east-1_C3WAL0u2C',
    userPoolWebClientId: '1u9is29retjkb2dbfmklsae64q',
    authenticationFlowType: 'USER_SRP_AUTH'
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
